var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',{staticClass:"card-text text-secondary",attrs:{"path":"customerService.text","tag":"p"}},[_c('CustomerServiceEmail'),_c('CustomerServicePhone')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }